"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectWithdrawBodyToJSON = exports.RejectWithdrawBodyFromJSONTyped = exports.RejectWithdrawBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function RejectWithdrawBodyFromJSON(json) {
    return RejectWithdrawBodyFromJSONTyped(json, false);
}
exports.RejectWithdrawBodyFromJSON = RejectWithdrawBodyFromJSON;
function RejectWithdrawBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
    };
}
exports.RejectWithdrawBodyFromJSONTyped = RejectWithdrawBodyFromJSONTyped;
function RejectWithdrawBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'notes': value.notes,
    };
}
exports.RejectWithdrawBodyToJSON = RejectWithdrawBodyToJSON;
